import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "employers__content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "strong" }, " Wir stellen ein: ", -1)
const _hoisted_4 = { class: "job-offers-list" }
const _hoisted_5 = {
  key: 0,
  class: "icon-row"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-chevron-right" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "strong" }, " Was wir bieten: ", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "employer__contact" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "strong" }, " Kontaktdaten: ", -1)
const _hoisted_11 = {
  key: 0,
  class: "icon-row card-partner__address"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-location-dot" })
], -1)
const _hoisted_13 = {
  key: 1,
  class: "icon-row card-partner__phone"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-phone-alt" })
], -1)
const _hoisted_15 = {
  key: 2,
  class: "icon-row card-partner__mail"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-envelope" })
], -1)
const _hoisted_17 = {
  key: 3,
  class: "icon-row card-partner__website"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-globe" })
], -1)
const _hoisted_19 = ["href"]

import { computed } from 'vue';
import Expand from '@/components/Expand.vue';
import LazyImage from '@/components/LazyImage.vue';

// eslint-disable-next-line no-undef,@typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'CardEmployer',
  props: {
  employer: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;

const getImageSrc = (imageUrl: string) => {
  if (imageUrl.endsWith('.webp')) {
    return imageUrl.substr(0, imageUrl.length - 5);
  }

  return imageUrl.substr(0, imageUrl.length - 4);
};

const getImageFormats = (imageUrl: string) => {
  if (imageUrl.endsWith('.jpg')) {
    return ['jpg'];
  }
  if (imageUrl.endsWith('.png')) {
    return ['png'];
  }

  return ['webp'];
};

const formattedWebsite = computed(() => {
  const website = props.employer.website?.trim() || '';
  if (website && !/^https?:\/\//i.test(website)) {
    return `https://${website}`;
  }
  return website;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Expand, null, {
    image: _withCtx(() => [
      (__props.employer.image)
        ? (_openBlock(), _createBlock(LazyImage, {
            key: 0,
            src: getImageSrc(__props.employer.image),
            formats: getImageFormats(__props.employer.image),
            "high-res": false
          }, null, 8, ["src", "formats"]))
        : _createCommentVNode("", true)
    ]),
    headline: _withCtx(() => [
      _renderSlot(_ctx.$slots, "headline", {}, () => [
        _createTextVNode(_toDisplayString(__props.employer.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", {
          innerHTML: __props.employer.companyText
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.employer.jobOffers, (jobOffer, inx) => {
            return (_openBlock(), _createElementBlock("div", { key: inx }, [
              (jobOffer.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", null, _toDisplayString(jobOffer), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _hoisted_7,
        _createElementVNode("p", {
          class: "employers__offers",
          innerHTML: __props.employer.offers
        }, null, 8, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (__props.employer.address && __props.employer.address.trim() !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", null, _toDisplayString(__props.employer.address), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.employer.phone && __props.employer.phone.trim() !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", null, _toDisplayString(__props.employer.phone.trim()), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.employer.email && __props.employer.email.trim() !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", null, _toDisplayString(__props.employer.email), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.employer.website && __props.employer.website.trim() !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: formattedWebsite.value,
                    target: "_blank"
                  }, _toDisplayString(__props.employer.website), 9, _hoisted_19)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }))
}
}

})